import {createAsyncThunk} from '@reduxjs/toolkit'

import {openNewTab} from '@web/helpers/browser'
import {isMobile} from '@web/helpers/userAgent'

import {ThunkApi} from '../interfaces'

const CULTURELAND_ID_FINDING_URL = `https://www.cultureland.co.kr/signin/findId/mobileAuth.do`
const CULTURELAND_ID_FINDING_MOBILE_URL = `https://m.cultureland.co.kr/mmb/searchId.do`

/**
 * 컬쳐랜드 상품권 로그인정보찾기 페이지 이동
 */
const navigateToCultureLandIdFinding = createAsyncThunk<Promise<string | unknown>, void, ThunkApi>(
    'navigateTo/cultureLandIdFinding',
    async () => {
        const url = isMobile ? CULTURELAND_ID_FINDING_MOBILE_URL : CULTURELAND_ID_FINDING_URL

        openNewTab({url})
        // page 이동은 그 자체로 추가동작 없이 resolve 된다
        return Promise.resolve()
    },
)

export default navigateToCultureLandIdFinding
